import { Loader } from '@googlemaps/js-api-loader';

const GoogleMap = () => {

    // Google Maps API Loader
    const loader = new Loader({
        apiKey: 'AIzaSyCXL6ULdbq_FftOxkiDBdQsmuSYzLbWfwo',
        version: "weekly",
        libraries: ["places"]
    });

    // When the library has loaded, proceed
    loader
        .load()
        .then((google) => {

            // Set up the markers available
            const defaultMarker = '/app/themes/adaptable/assets/dist/vectors/map-pin.svg';
            const featuredMarker = '/app/themes/adaptable/assets/dist/vectors/map-pin--featured.svg';

            // Set up active class for marker cards
            const activeclass = 'google-map__card--active';

            // Global map options
            const mapOptions = {
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                disableDefaultUI: true,
                center: {
                    lat: 0, lng: 0
                },
                zoom: 15,
                styles: [
                    { elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
                    { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
                    { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
                    { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] },
                    {
                        featureType: 'administrative.land_parcel',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#bdbdbd' }],
                    },
                    {
                        featureType: 'poi',
                        elementType: 'geometry',
                        stylers: [{ color: '#eeeeee' }],
                    },
                    {
                        featureType: 'poi',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#757575' }],
                    },
                    {
                        featureType: 'poi.park',
                        elementType: 'geometry',
                        stylers: [{ color: '#e5e5e5' }],
                    },
                    {
                        featureType: 'poi.park',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#9e9e9e' }],
                    },
                    {
                        featureType: 'road',
                        elementType: 'geometry',
                        stylers: [{ color: '#ffffff' }],
                    },
                    {
                        featureType: 'road.arterial',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#757575' }],
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'geometry',
                        stylers: [{ color: '#FFFFFF' }],
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#616161' }],
                    },
                    {
                        featureType: 'road.local',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#9e9e9e' }],
                    },
                    {
                        featureType: 'transit.line',
                        elementType: 'geometry',
                        stylers: [{ color: '#e5e5e5' }],
                    },
                    {
                        featureType: 'transit.station',
                        elementType: 'geometry',
                        stylers: [{ color: '#eeeeee' }],
                    },
                    {
                        featureType: 'water',
                        elementType: 'geometry',
                        stylers: [{ color: '#c9c9c9' }],
                    },
                    {
                        featureType: 'water',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#9e9e9e' }],
                    },
                ],
            }

            // Fetch all maps on the page to render
            const mapElements = document.querySelectorAll('[data-google-map]');

            // Loop through each map
            Array.from(mapElements).forEach(mapElement => {

                // Create a new map
                const map = new google.maps.Map(mapElement.querySelector('[data-map-element]'), mapOptions);

                // Fetch all markers for this particular map
                const markers = mapElement.querySelectorAll('[data-map-card]');

                // Array to allow us to access all markers
                var allMarkers = [];

                // Loop through each marker
                Array.from(markers).forEach(mapMarker => {
                    // create a new marker for each point
                    let marker = new google.maps.Marker({
                        position: { lat: parseFloat( mapMarker.getAttribute('data-lat')), lng: parseFloat(mapMarker.getAttribute('data-lng')) },
                        map: map,
                        icon: defaultMarker,
                        title: mapMarker.getAttribute('data-marker-title'),
                        id: mapMarker.getAttribute('data-map-card')
                    });

                    // Add this marker to our markers array
                    allMarkers.push(marker);

                    // When the marker is clicked
                    marker.addListener('click', () => {
                        // Get the correspondng card ID
                        const cardId = marker.id;

                        // Fetch the card by the matching ID
                        const card = document.querySelector(`[data-map-card="${cardId}"]`);

                        // Ensure that no markers are currently active/bouncing and all are using the default icon
                        allMarkers.forEach((marker) => {
                            marker.setAnimation(null);
                            marker.setIcon(defaultMarker);
                        });

                        // Remove the active state from all other marker cards
                        Array.from(markers).forEach(mapMarker => {
                            mapMarker.classList.remove(activeclass);
                        });

                        // Set the current marker to bounce and use the featured icon
                        marker.setAnimation(google.maps.Animation.BOUNCE);
                        marker.setIcon(featuredMarker);

                        // Set the current markers' card to active to show the information
                        if (typeof card != "undefined" && card != null) {
                            card.classList.add(activeclass);
                        }
                    });
                });

                // Now that the markers are in place, fetch the current map bounds
                const bounds = new google.maps.LatLngBounds();

                // loop through all markers and create bounds
                allMarkers.forEach((marker) => {
                    const latlng = new google.maps.LatLng(
                        marker.position.lat(),
                        marker.position.lng()
                    );

                    // Set the map bounds to extend to all markers
                    bounds.extend(latlng);
                });

                // If there is only 1 marker, just set the map to centre on the pin
                if (allMarkers.length === 1) {
                    // set center of map
                    map.setCenter(bounds.getCenter());
                    map.setZoom(16);
                } else {
                    // fit the map bounds to the enclosed markers
                    map.fitBounds(bounds);
                }

                // Add click handlers for each close button within this map element
                const closeButtons = mapElement.querySelectorAll('[data-close-button]');

                Array.from(closeButtons).forEach(closeButton => {

                    // Add a click handler to every close button
                    closeButton.addEventListener('click', e => {

                        e.preventDefault();

                        // Get the correspondng card ID
                        const cardId = closeButton.getAttribute('data-close-button');

                        // Fetch the card by the matching ID
                        const card = document.querySelector(`[data-map-card="${cardId}"]`);

                        // Remove the active class
                        if (typeof card != "undefined" && card != null) {
                            card.classList.remove(activeclass);
                        }

                        // Ensure that no markers are currently active/bouncing
                        allMarkers.forEach((marker) => {
                            marker.setAnimation(null);
                            marker.setIcon(defaultMarker);
                        });
                    });

                });
            });

        })
}

export default GoogleMap;
